import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { linkAccountManuallySchema } from './link-account-manually-schema';

export interface LinkAccountManuallyFormFields {
  accountId: string;
}

interface UseLinkAccountManuallyFormHook {
  form: UseFormReturn<LinkAccountManuallyFormFields>;
}

export const useLinkAccountManuallyForm = (): UseLinkAccountManuallyFormHook => {
  const formResolver = yupResolver(linkAccountManuallySchema);

  const form = useForm<LinkAccountManuallyFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: {
      accountId: '',
    },
  });

  return { form };
};
